import $ from "jquery";
import "jquery-mousewheel";
import { gsap } from "gsap";

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var totalImages = $('img').length;
var imagesLoaded = 0;

var imageLoaded = function() {

    imagesLoaded++;

    if (imagesLoaded == totalImages)
    {
        setTimeout(function() {
            imagesLoaded = 9999;
            refresh();
            $('body').addClass('initialized');
        }, 200);
    }

    setTimeout(function() {

        if (!$('body').hasClass('initialized'))
        {
            refresh();
            $('body').addClass('initialized');
        }
    }, 15000);
};

$('img').each(function(idx, img) {
    $('<img>').on('load', imageLoaded).attr('src', $(img).attr('src'));
});




// -------------------------------------------------------------------------- //
// Screen 1
// -------------------------------------------------------------------------- //

var hideScreen1Timeline = gsap.timeline({paused: true});

hideScreen1Timeline.to('#screen-1 .man img', { duration: 1, x: '-36%', y: '70%', scale: 4 })
           .to('#screen-1', { duration: 0.8, opacity: 0 }, 0.5)
           .set('#screen-1', { visibility: 'hidden' });

var hideScreen1TimelineMobile = gsap.timeline({paused: true});

hideScreen1TimelineMobile.to('#screen-1 .man img', { duration: 1, x: '0%', y: '0%', scale: 4 })
         .to('#screen-1', { duration: 0.8, opacity: 0 }, 0.5)
         .set('#screen-1', { visibility: 'hidden', onComplete: function() { $('#screen-1 .screen-inner').scrollTop(0); } });

 var hideScreen1TimelineMobileAlt = gsap.timeline({paused: true});

 hideScreen1TimelineMobileAlt.to('#screen-1 .man img', { duration: 1, x: '0%', y: '200%', scale: 4 })
          .to('#screen-1', { duration: 0.8, opacity: 0 }, 0.5)
          .set('#screen-1', { visibility: 'hidden', onComplete: function() { $('#screen-1 .screen-inner').scrollTop(0); } });

var currentScreen = 1;

var toggleScreen = function(index, history = true) {

   if (currentScreen !== index)
   {
       $(window).scrollTop(0);

       if (2 === index)
       {
           if (history)
           {
               window.history.pushState({screen: index, cell: 0}, window.location.href);
           }

           setTimeout(function() {
               $('body').attr('data-active-screen', index);
           }, 1000);

           if (isBreakpointDown())
           {
               if ($('#screen-1 .screen-inner').scrollTop() < ($('#screen-1 .screen-content').height() / 2))
               {
                    hideScreen1TimelineMobile.play();
               }
               else
               {
                   hideScreen1TimelineMobileAlt.play();
               }
           }
           else
           {
               hideScreen1Timeline.play();
           }
       }
       else
       {
           if (history)
           {
               window.history.pushState({screen: index}, window.location.href);
           }

           $('body').attr('data-active-screen', index);

           if (isBreakpointDown())
           {
               if (hideScreen1TimelineMobile.totalProgress() > 0)
               {
                   hideScreen1TimelineMobile.reverse();
               }
               else if (hideScreen1TimelineMobileAlt.totalProgress() > 0)
               {
                   hideScreen1TimelineMobileAlt.reverse();
               }
           }
           else
           {
               hideScreen1Timeline.reverse();
           }

            setTimeout(function() {

                toggleLeftPanel(0);
                toggleRightPanel(0);
                toggleCellGroup(0);
                bg_cells_pos_1();

                $('#screen-2 .cell-groups').removeClass('active');
                $('#screen-2 .cell-group.active').removeClass('active');

                //$('#header .header-navigation a.active').removeClass('active');
                //$('#screen-2 .cell-group-navigation a.active').removeClass('active');

                $('.cell-hl.active').removeClass('active');

            }, 1000);
        }

        currentScreen = index;
    }
};


$('[data-toggle-screen]').on('click', function(e) {
    e.preventDefault();
    toggleScreen($(this).data('toggle-screen'));
});





// -------------------------------------------------------------------------- //
// Screen 2
// -------------------------------------------------------------------------- //


// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var currentRightPanel = 0;

var refreshRightPanel = function(index = null) {
    index = index || $('#screen-2 .right-panel').data('active');
    gsap.to($('#right-panel .widget-1 .widget-body'), { duration: 0.5, height: $('#right-panel .widget-1 .item-' + index).height() });
};

var toggleRightPanel = function(index) {

    if (index)
    {
        $('#screen-2 .right-panel').addClass('active');
    }
    else
    {
        index = 1;
        $('#screen-2 .right-panel').removeClass('active');
    }

    if (currentRightPanel !== index)
    {
        var widget1 = $('#right-panel .widget-1'),
            container = widget1.find('.widget-body'),
            item = container.find('.item-' + index);

        $('#screen-2 .right-panel').attr('data-active', index);
        refreshRightPanel(index);

        var widget2 = $('#right-panel .widget-2'),
            container = widget2.find('.widget-number-container'),
            item = container.find('.item-' + index);

        $('#screen-2 .right-panel').attr('data-active', index);
        gsap.to(container, { duration: 0.5, width: item.width() });

        currentRightPanel = index;
    }
};

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var currentLeftPanel = 0;

var toggleLeftPanel = function(index) {

    $('#screen-2 .left-panel').addClass('active');

    if (currentLeftPanel !== index)
    {
        $('#screen-2 .left-panel-item.active').removeClass('active');
        $('#screen-2 .left-panel-item-' + index).toggleClass('active');

        currentLeftPanel = index;
    }
};


var currentBreakpoint = $(window).width() < 1200 ? 'down' : 'up';

var isBreakpointDown = function()
{
    return $(window).width() < 1200;
};

$(window).on('resize', function() {

    if ('up' === currentBreakpoint && $(window).width() < 1200)
    {
        currentBreakpoint = 'down';
        toggleCellGroup(currentCellGroup, true);
    }
    else if ('down' === currentBreakpoint && $(window).width() >= 1200)
    {
        currentBreakpoint = 'up';
        toggleCellGroup(currentCellGroup, true);
    }
});





// -------------------------------------------------------------------------- //



var cell_1_1_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '140%', x: '-32%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '40%', x: '184%', y: '0%' });
    }

    gsap.to('#screen-2 .cell-1 img', { duration: 0.7, rotation: -75, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_1_1_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '-32%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '73.5%', x: '22%', y: '12%' });
    }

    gsap.to('#screen-2 .cell-1 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_1_1_pos_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '-130%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '18%', x: '38%', y: '140%' });
    }

    gsap.to('#screen-2 .cell-1 img', { duration: 0.7, rotation: -75, webkitFilter: 'blur(5px)', filter: 'blur(5px)' });
};

var cell_1_1_pos_3 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '-190%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 1, visibility: 'visible', width: '28%', x: '-15%', y: '153%' });
    }

    gsap.to('#screen-2 .cell-1 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(3px)', filter: 'blur(3px)' });
};

var cell_1_hide = function() {
    gsap.to('#screen-2 .cell-1', { duration: 0.7, opacity: 0 });
    gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 0 });
    gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 0 });
};

// -------------------------------------------------------------------------- //


var cell_1_2_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 0, visibility: 'hidden', width: '160%', x: '-24%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 0, visibility: 'hidden', width: '28%', x: '-2%', y: '148%' });
    }

    gsap.to('#screen-2 .cell-1-2 img', { duration: 0.7, rotation: -105, webkitFilter: 'blur(3px)', filter: 'blur(3px)' });
};

var cell_1_2_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '160%', x: '-24%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '73%', x: '30%', y: '10%' });
    }

    gsap.to('#screen-2 .cell-1-2 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_1_2_pos_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '160%', x: '-130%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '19%', x: '39%', y: '100%' });
    }

    gsap.to('#screen-2 .cell-1-2 img', { duration: 0.7, rotation: -75, webkitFilter: 'blur(5px)', filter: 'blur(5px)' });
};

var cell_1_2_pos_3 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '160%', x: '80%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '35%', x: '-18%', y: '114%' });
    }

    gsap.to('#screen-2 .cell-1-2 img', { duration: 0.7, rotation: -105, webkitFilter: 'blur(3px)', filter: 'blur(3px)' });
};

// -------------------------------------------------------------------------- //


var cell_1_3_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 0, visibility: 'hidden', width: '170%', x: '180%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 0, visibility: 'hidden', width: '18%', x: '38%', y: '140%' });
    }

    gsap.to('#screen-2 .cell-1-3 img', { duration: 0.7, rotation: -75, webkitFilter: 'blur(5px)', filter: 'blur(5px)' });
};

var cell_1_3_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '-24%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '73%', x: '30%', y: '10%' });
    }

    gsap.to('#screen-2 .cell-1-3 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_1_3_pos_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '180%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '18%', x: '38%', y: '140%' });
    }

    gsap.to('#screen-2 .cell-1-3 img', { duration: 0.7, rotation: -75, webkitFilter: 'blur(5px)', filter: 'blur(5px)' });
};

var cell_1_3_pos_3 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '80%', y: '0%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-1-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '27%', x: '-28%', y: '146%' });
    }

    gsap.to('#screen-2 .cell-1-3 img', { duration: 0.7, rotation: -60, webkitFilter: 'blur(3px)', filter: 'blur(3px)' });
};


// -------------------------------------------------------------------------- //

var cell_2_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '160%', x: '2%', y: '104%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '45%', x: '91%', y: '66%' });
    }

    gsap.to('#screen-2 .cell-2 img', { duration: 0.7, opacity: 1, visibility: 'visible', rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_2_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '200%', x: '-30%', y: '-4%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-2', { duration: 0.7, opacity: 1, visibility: 'visible', width: '100%', x: '0%', y: '0%' });
    }

    gsap.to('#screen-2 .cell-2 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_2_hide = function() {
    gsap.to('#screen-2 .cell-2', { duration: 0.7, opacity: 0 });
};


// -------------------------------------------------------------------------- //

var cell_3_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '140%', x: '-30%', y: '196%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '40%', x: '177%', y: '134%' });
    }

    gsap.to('#screen-2 .cell-3 img', { duration: 0.7, opacity: 1, visibility: 'visible', rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_3_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '170%', x: '-20%', y: '-4%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-3', { duration: 0.7, opacity: 1, visibility: 'visible', width: '88%', x: '10%', y: '0%' });
    }

    gsap.to('#screen-2 .cell-3 img', { duration: 0.7, rotation: 0, webkitFilter: 'blur(0px)', filter: 'blur(0px)' });
};

var cell_3_hide = function() {
    gsap.to('#screen-2 .cell-3', { duration: 0.7, opacity: 0 });
};





var currentCellGroup = 0;

var toggleCellGroup = function(index, force = false, history = true) {

    if (currentCellGroup !== index || force)
    {
        if (history)
        {
            window.history.pushState({cell: index}, window.location.href);
        }

        if ($('#screen-2 .cell-groups').hasClass('active'))
        {
            $('#screen-2 .cell-group.active').removeClass('active');
            $('#screen-2 .cell-group-' + index).addClass('active');
        }
        else
        {
            $('#screen-2 .cell-groups').addClass('active');
            $('#screen-2 .cell-group.active').removeClass('active');
            $('#screen-2 .cell-group-' + index).addClass('active');

            bg_cells_pos_1();
        }

        if (isBreakpointDown())
        {
            $(window).scrollTop(0);
        }

        toggleRightPanel(index);
        toggleLeftPanel(index);

        $('[data-toggle-cell-group].active').removeClass('active');
        $('[data-toggle-cell-group="' + index + '"]').addClass('active');

        if (1 === index)
        {
            cell_1_1_pos_1();
            cell_1_2_pos_3();
            cell_1_3_pos_2();
            cell_detail_buttons_pos_1();
            cell_2_hide();
            cell_3_hide();
            toggleCellGroup1Cell(1);

            if (1 === currentScreen)
            {
                toggleScreen(2);
            }
        }
        else if (2 === index)
        {
            cell_2_pos_1();
            cell_detail_buttons_pos_2();
            cell_1_hide();
            cell_3_hide();

            if (1 === currentScreen)
            {
                toggleScreen(2);
            }
        }
        else if (3 === index)
        {
            cell_3_pos_1();
            cell_detail_buttons_pos_3();
            cell_1_hide();
            cell_2_hide();

            if (1 === currentScreen)
            {
                toggleScreen(2);
            }
        }
        else
        {
            cell_1_1_pos_0();
            cell_1_2_pos_0();
            cell_1_3_pos_0();
            cell_2_pos_0();
            cell_3_pos_0();
            cell_detail_buttons_pos_0();
            $('#screen-2 .cell-groups').removeClass('active');

        }

        window.globalRefresh();

        $('body').attr('data-active-cell-group', index);

        currentCellGroup = index;
    }
};



$('[data-toggle-cell-group]').on('click', function(e) {
    e.preventDefault();
    toggleCellGroup($(this).data('toggle-cell-group'));
});






var currentCellGroup1Cell = 1;

var toggleCellGroup1Cell = function(index) {

    if (currentCellGroup1Cell !== index)
    {
        $('[data-toggle-cell-group-1-cell].active').removeClass('active');
        $('[data-toggle-cell-group-1-cell="' + index + '"]').addClass('active');

        if (1 === index)
        {
            cell_1_1_pos_1();
            cell_1_3_pos_2();
            cell_1_2_pos_3();
            cell_detail_buttons_pos_1();

            bg_cells_pos_1();

            toggleSidePanelPane(101,1);
            $('.t-cell-content').show(0);
            $('.b-cell-content').hide(0);
        }
        else if (2 === index)
        {
            cell_1_2_pos_1();
            cell_1_1_pos_2();
            cell_1_3_pos_3();
            cell_detail_buttons_pos_1_2();

            bg_cells_pos_2();

            toggleSidePanelPane(101,2);
            $('.t-cell-content').hide(0);
            $('.b-cell-content').show(0);
        }
        else if (3 === index)
        {
            cell_1_3_pos_1();
            cell_1_2_pos_2();
            cell_1_1_pos_3();
            cell_detail_buttons_pos_1_3();

            bg_cells_pos_3();
        }
        else
        {
            cell_1_1_pos_0();
            cell_1_2_pos_0();
            cell_1_3_pos_0();
            cell_detail_buttons_pos_0();

            bg_cells_pos_1();
        }

        currentCellGroup1Cell = index;
    }
};

$('[data-toggle-cell-group-1-cell]').on('click', function(e) {
    e.preventDefault();
    toggleCellGroup1Cell($(this).data('toggle-cell-group-1-cell'));
});



$('.side-panel-101 [data-toggle-side-panel-pane="1"]').on('click', function(e) {
    $('.t-cell-content').show(0);
    $('.b-cell-content').hide(0);
});

$('.side-panel-101 [data-toggle-side-panel-pane="2"]').on('click', function(e) {
    $('.t-cell-content').hide(0);
    $('.b-cell-content').show(0);
});



// -------------------------------------------------------------------------- //
// Side Panels
// -------------------------------------------------------------------------- //

// -------------------------------------------------------------------------- //

var bg_cells_pos_1 = function() {
    gsap.to('#screen-2 .screen-2-bg-cell-1', { duration: 0.7, x: '-5%', y: '10%' });
    gsap.to('#screen-2 .screen-2-bg-cell-2', { duration: 0.7, x: '100%' });
    gsap.to('#screen-2 .screen-2-bg-cell-3', { duration: 0.7, x: '-100%' });
    gsap.to('#screen-2 .screen-2-bg-cell-4', { duration: 0.7, x: '-39%', y: '-4%' });
    gsap.to('#screen-2 .screen-2-bg-cell-5', { duration: 0.7, x: '0%', y: '0%' });
};

var bg_cells_pos_2 = function() {
    gsap.to('#screen-2 .screen-2-bg-cell-1', { duration: 0.7, x: '5%', y: '10%' });
    gsap.to('#screen-2 .screen-2-bg-cell-4', { duration: 0.7, x: '-19%', y: '-2%' });
    gsap.to('#screen-2 .screen-2-bg-cell-5', { duration: 0.7, x: '0%', y: '-6%' });
};

var bg_cells_pos_3 = function() {
    gsap.to('#screen-2 .screen-2-bg-cell-1', { duration: 0.7, x: '0%', y: '0%' });
    gsap.to('#screen-2 .screen-2-bg-cell-4', { duration: 0.7, x: '0%', y: '0%' });
    gsap.to('#screen-2 .screen-2-bg-cell-5', { duration: 0.7, x: '-6%', y: '4%' });
};



// -------------------------------------------------------------------------- //
// Side Panels
// -------------------------------------------------------------------------- //

var cell_detail_button_1_pos_0 = function() {
    gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 0, visibility: 'hidden', x: '99%', y: '27%' });
};

var cell_detail_button_1_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '65%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 1, visibility: 'visible', x: '99%', y: '27%' });
    }
};

var cell_detail_button_1_pos_1_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '140%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 1, visibility: 'visible', x: '61%', y: '159%' });
    }
};

var cell_detail_button_1_pos_1_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_1_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_1_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-1', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

// ----- //

var cell_detail_button_2_pos_0 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 0, visibility: 'hidden', x: '10%', y: '51%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 0, visibility: 'hidden', x: '55%', y: '51%' });
    }
};

var cell_detail_button_2_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '90%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '55%', y: '51%' });
    }
};

var cell_detail_button_2_pos_1_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '90%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '51%', y: '100%' });
    }
};

var cell_detail_button_2_pos_1_3 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '115%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 1, visibility: 'visible', x: '82%', y: '33%' });
    }
};

var cell_detail_button_2_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_2_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-2', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

// ----- //

var cell_detail_button_3_pos_0 = function() {
    gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 0, visibility: 'hidden', x: '84%', y: '81%' });
};

var cell_detail_button_3_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '115%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '84%', y: '81%' });
    }
};

var cell_detail_button_3_pos_1_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '115%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '93%', y: '71%' });
    }
};

var cell_detail_button_3_pos_1_3 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '90%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 1, visibility: 'visible', x: '72%', y: '101%' });
    }
};

var cell_detail_button_3_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_3_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-3', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

// ----- //

var cell_detail_button_4_pos_0 = function() {
    gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 0, visibility: 'hidden', x: '105%', y: '135%' });
};

var cell_detail_button_4_pos_1 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '140%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 1, visibility: 'visible', x: '105%', y: '135%' });
    }
};

var cell_detail_button_4_pos_1_2 = function() {

    if (isBreakpointDown())
    {
        gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 1, visibility: 'visible', x: '2%', y: '65%' });
    }
    else
    {
        gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 1, visibility: 'visible', x: '52%', y: '126%' });
    }
};

var cell_detail_button_4_pos_1_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_4_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_4_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-4', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

// ----- //

var cell_detail_button_5_pos_0 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_5_pos_1 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_5_pos_1_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_5_pos_1_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

var cell_detail_button_5_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 1, visibility: 'visible' });
};

var cell_detail_button_5_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-5', { duration: 0.7, opacity: 0, visibility: 'hidden' });
};

// ----- //

var cell_detail_button_6_pos_0 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 0 });
};

var cell_detail_button_6_pos_1 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 0 });
};

var cell_detail_button_6_pos_1_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 0 });
};

var cell_detail_button_6_pos_1_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 0 });
};

var cell_detail_button_6_pos_2 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 0 });
};

var cell_detail_button_6_pos_3 = function() {
    gsap.to('#screen-2 .cell-detail-button-6', { duration: 0.7, opacity: 1, visibility: 'visible' });
};


var cell_detail_buttons_pos_0 = function() {
    cell_detail_button_1_pos_0();
    cell_detail_button_2_pos_0();
    cell_detail_button_3_pos_0();
    cell_detail_button_4_pos_0();
    cell_detail_button_5_pos_0();
    cell_detail_button_6_pos_0();
};

var cell_detail_buttons_pos_1 = function() {
    cell_detail_button_1_pos_1();
    cell_detail_button_2_pos_1();
    cell_detail_button_3_pos_1();
    cell_detail_button_4_pos_1();
    cell_detail_button_5_pos_1();
    cell_detail_button_6_pos_1();
};

var cell_detail_buttons_pos_1_2 = function() {
    cell_detail_button_1_pos_1_2();
    cell_detail_button_2_pos_1_2();
    cell_detail_button_3_pos_1_2();
    cell_detail_button_4_pos_1_2();
    cell_detail_button_5_pos_1_2();
    cell_detail_button_6_pos_1_2();
};

var cell_detail_buttons_pos_1_3 = function() {
    cell_detail_button_1_pos_1_3();
    cell_detail_button_2_pos_1_3();
    cell_detail_button_3_pos_1_3();
    cell_detail_button_4_pos_1_3();
    cell_detail_button_5_pos_1_3();
    cell_detail_button_6_pos_1_3();
};

var cell_detail_buttons_pos_2 = function() {
    cell_detail_button_1_pos_2();
    cell_detail_button_2_pos_2();
    cell_detail_button_3_pos_2();
    cell_detail_button_4_pos_2();
    cell_detail_button_5_pos_2();
    cell_detail_button_6_pos_2();
};

var cell_detail_buttons_pos_3 = function() {
    cell_detail_button_1_pos_3();
    cell_detail_button_2_pos_3();
    cell_detail_button_3_pos_3();
    cell_detail_button_4_pos_3();
    cell_detail_button_5_pos_3();
    cell_detail_button_6_pos_3();
};


// -------------------------------------------------------------------------- //
// Side Panels
// -------------------------------------------------------------------------- //

var toggleSidePanel = function(index) {

    var panel = $('#side-panels .side-panel-' + index),
        isActive = panel.hasClass('active');

    $('#side-panels .side-panel:not(.side-panel-' + index + ').active').removeClass('active');

    if (!isActive)
    {
        panel.find('.ps').scrollTop(0);
        panel.find('.side-panel-container-inner').scrollTop(0);
        //panel.find('.side-panel-navigation a').click();
        if (101 !== index && '101' !== index)
        {
            toggleSidePanelPane(index, 1);
        }
        $('body').addClass('side-panel-active');
        panel.addClass('active');
    }
    else
    {
        panel.removeClass('active');
        $('body').removeClass('side-panel-active');
    }
};

$('[data-toggle-side-panel]').on('click', function(e) {
    e.preventDefault();
    toggleSidePanel($(this).data('toggle-side-panel'));
});


var toggleSidePanelPane = function(panelIndex, paneIndex) {

    var panel = $('.side-panel-' + panelIndex),
        pane = panel.find('.side-panel-pane-' + paneIndex);

    if (pane)
    {
        var nav = panel.find('.side-panel-navigation');

        nav.find('.active').removeClass('active');
        panel.find('.side-panel-pane.active').removeClass('active');

        nav.find('li:nth-child(' + (paneIndex) + ') a').addClass('active');
        pane.addClass('active');
    }
};

$('[data-toggle-side-panel-pane]').on('click', function(e) {
    e.preventDefault();
    var data = $(this).data('toggle-side-panel-pane').split(',');
    toggleSidePanelPane(data[0], data[1]);
});


$('.cell-detail-button').hover(
    function() {

        var highlight = $(this).index() + 1,
            currentCell = (1 === currentCellGroup && currentCellGroup1Cell > 1) ? '1-' + currentCellGroup1Cell : currentCellGroup;

        $('.cell-hl.active').removeClass('active');
        $('.cell-' + currentCell + '-hl-' + highlight).addClass('active');
    },
    function() {

        $('.cell-hl.active').removeClass('active');
    }
);





// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

$('[data-toggle-comparison-table]').on('click', function(e) {

    e.preventDefault();

    var open = $(this).data('toggle-comparison-table');

    if (typeof open !== undefined && '' !== open)
    {
        $('.comparison-table')[open ? 'addClass' : 'removeClass']('active');
    }
    else
    {
        $('.comparison-table').toggleClass('active');
    }

    if ($('.comparison-table').hasClass('active'))
    {
        $('body').addClass('comparison-table-active');
        $(window).scrollTop(0);
    }
    else
    {
        $('body').removeClass('comparison-table-active');
    }

});


$('[data-toggle-comparison-table-row]').on('click', function(e) {

    e.preventDefault();

    var button = $(this),
        table = button.closest('.comparison-table'),
        index = button.data('toggle-comparison-table-row');

    table.find('.comparison-table-navigation a.active').removeClass('active');
    button.addClass('active');

    table.find('.row.active').removeClass('active');
    table.find('.row-' + index).addClass('active');
});





var refresh = function() {

    window.globalRefresh();

    refreshRightPanel();

    $('.side-panel-navigation-inner').each(function() {
        $(this).width($(this).closest('.side-panel-navigation').width());
    });
}

$(window).resize(function() {
    refresh();
});







var homeBannerParallax = function(el, resistance, mouse)
{
    gsap.to(el, 0.2, {
        x: -((mouse.clientX - window.innerWidth / 2) / resistance),
        y: -((mouse.clientY - window.innerHeight / 2) / resistance)
    });
};

var homeBannerParallaxAlt = function(el, resistance, mouse)
{
    gsap.to(el, 0.2, {
        x: -((mouse.clientY - window.innerWidth / 2) / resistance),
        y: -((mouse.clientX - window.innerHeight / 2) / resistance)
    });
};



$('body').mousemove(function(e) {

        homeBannerParallax($('#screen-2 .screen-bg-cells'), -140, e);

        homeBannerParallax($('#screen-2 .cell-1 > div'), 140, e);
        homeBannerParallaxAlt($('#screen-2 .cell-1-2 > div'), -120, e);
        homeBannerParallaxAlt($('#screen-2 .cell-1-3 > div'), 130, e);
        homeBannerParallax($('#screen-2 .cell-2 > div'), -120, e);
        homeBannerParallaxAlt($('#screen-2 .cell-3 > div'), -130, e);
});








var scrollBuffer = 0,
    scrollBufferTimeout = 0;

//DOMMouseScroll

$('#screen-1 .screen-inner').on('wheel touchmove', function(e) {

    if ($(window).width() >= 1200 && 1 === currentScreen)
    {
        scrollBuffer++;

        if (scrollBuffer > 10)
        {
            toggleScreen(2);

            if (Munchkin)
            {
                Munchkin.munchkinFunction('clickLink', {
                    'href': location.pathname + '#entered'
                });
            }
        }

        clearTimeout(scrollBufferTimeout);

        scrollBufferTimeout = setTimeout(function() {
            scrollBuffer = 0;
        }, 100);
    }
});

$('#screen-1 .screen-inner').on('mousewheel', function(e) {

    if ($(window).width() >= 1200 && 1 === currentScreen)
    {
        toggleScreen(2);

        if (Munchkin)
        {
            Munchkin.munchkinFunction('clickLink', {
                'href': location.pathname + '#entered'
            });
        }
    }
});

$('#screen-1 .screen-inner').on('scroll', function(e) {

    if ($(window).width() < 1200 && 1 === currentScreen)
    {
        var root = $(this),
            top = root.scrollTop();

        if (Math.round(root.find('.screen-content').outerHeight()) === Math.round(top + $(window).height()))
        {
            toggleScreen(2);

            if (Munchkin)
            {
                Munchkin.munchkinFunction('clickLink', {
                    'href': location.pathname + '#entered'
                });
            }
        }
    }

    $('body')[top > 0 ? 'addClass' : 'removeClass']('scrolled-inner');
});

window.onpopstate = function(e) {

    var state = e.state;

    if (state != null)
    {
        $('.comparison-table').removeClass('active');
        $('#side-panels .side-panel.active').removeClass('active');

        if (state.hasOwnProperty('screen'))
        {
            toggleScreen(state.screen, false);
        }

        if (state.hasOwnProperty('cell'))
        {
            toggleCellGroup(state.cell, true, false);
        }
    }
    else
    {
        window.history.back();
    }
};

window.onload = function() {
    window.history.pushState({screen: 1}, window.location.href);
}
